import {
  Center,
  CircularProgress as ChakraCircularProgress,
  CircularProgressLabel,
  Text,
  useMediaQuery,
} from "@chakra-ui/react";

export default function CircularProgress({
  name,
  label,
  value,
  color,
  variant = "normal",
}) {
  const [isMobile] = useMediaQuery("(min-width: 992px)");

  return (
    <Center flexDir="column" gap="0">
      <ChakraCircularProgress
        value={value}
        size={!isMobile ? "78px" : "94px"}
        thickness="5px"
        capIsRound={true}
        color={color}
        trackColor={variant === "normal" ? "#E5E5E5" : "white"}
        className="circular_stroke"
      >
        <CircularProgressLabel
          fontSize={["sm", "16px"]}
          fontWeight={600}
          color={variant === "normal" ? "#5C6066" : "white"}
          isTruncated
          maxWidth={!isMobile ? "52px" : "72px"}
        >
          {label}
        </CircularProgressLabel>
      </ChakraCircularProgress>
      {name && (
        <Text as="span" fontSize="sm">
          {name}
        </Text>
      )}
    </Center>
  );
}
